<template>
  <div class="publicMain">
    <!--        <el-row class="leftClass">-->
    <!--            <el-col :span="8">-->
    <!--                <el-button-group>-->
    <!--                    <el-button type="primary" size="small" :class="{ btnColor: btnColor == 3 }" @click="btncolorTab('query','3')">全部</el-button>-->
    <!--                    <el-button type="primary" size="small" :autofocus="true" :class="{ btnColor: btnColor == 1 }" @click="btncolorTab('query','1')">已发布</el-button>-->
    <!--                    <el-button type="primary" size="small" :class="{ btnColor: btnColor == 0 }" @click="btncolorTab('query','0')">草稿</el-button>-->
    <!--                </el-button-group>-->
    <!--            </el-col>-->
    <!--        </el-row>-->
    <el-row class="rightClass">
      <el-col :span="12" style="text-align: left;">
        <el-button
          type="primary"
          size="small"
          :class="{ btnColor: btnColor == 3 }"
          @click="openDialog('add')"
          >{{$t('common.addedBtn')}}</el-button
        >
      </el-col>
      <el-col :span="12">
        <el-button-group>
          <el-button
            type="primary"
            size="small"
            :class="{ btnColor: btnColor == 3 }"
            @click="btncolorTab('query', '3')"
            >{{$t('common.all')}}</el-button
          >
          <el-button
            type="primary"
            size="small"
            :autofocus="true"
            :class="{ btnColor: btnColor == 1 }"
            @click="btncolorTab('query', '1')"
            >{{$t('common.yfb')}}</el-button
          >
          <el-button
            type="primary"
            size="small"
            :class="{ btnColor: btnColor == 0 }"
            @click="btncolorTab('query', '0')"
            >{{$t('common.draft')}}</el-button
          >
        </el-button-group>
      </el-col>
    </el-row>
    <el-row>
      <el-table
        v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
        :data="tableData"
        border
        style="width: 100%; font-size: 12px;"
        :header-cell-style="$store.state.headerCellStyle"
        :cell-style="$store.state.cellStyle"
      >
        <el-table-column
          prop="lxmc"
          :label="$t('rcsw.type')"
          width="100px"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="fwmc"
          :label="$t('rcsw.service')"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="fwjj"
          :label="$t('rcsw.synopsis')"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="qssj"
          :label="$t('common.qztime')"
          width="280px"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.qssj.slice(0, 4) }}-{{ scope.row.qssj.slice(4, 6) }}-{{
              scope.row.qssj.slice(6, 8)
            }}
            ~ {{ scope.row.jzsj.slice(0, 4) }}-{{
              scope.row.jzsj.slice(4, 6)
            }}-{{ scope.row.jzsj.slice(6, 8) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="cjsj"
          :label="$t('common.createAt')"
          width="150px"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.cjsj.slice(0, 4) }}-{{ scope.row.cjsj.slice(4, 6) }}-{{
              scope.row.cjsj.slice(6, 8)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="sfqy"
          :label="$t('rcsw.state')"
          width="120px"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{
              scope.row.sfqy == "1"
                ? $t('common.yfb')
                : scope.row.sfqy == "0"
                ? $t('common.draft')
                : $t('common.selectOff')
            }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.operation')"
          width="100px"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.sfqy == '0' || scope.row.lxid == '006'"
              @click="openDialog('edit', scope.row)"
              >{{$t('common.editBtn')}}</el-button
            >
            <el-button type="text" :disabled="true" v-else>{{$t('common.editBtn')}}</el-button>
            <el-button
              type="text"
              v-if="scope.row.sfqy == '0' || scope.row.lxid == '006'"
              @click="openDialog('del', scope.row)"
              >{{$t('common.deleteBtn')}}</el-button
            >
            <el-button type="text" :disabled="true" v-else>{{$t('common.deleteBtn')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-row>
      <!-- 分页组件 -->
      <Pagination
        :currentPage="currentPage"
        :total="total"
        :limit="limit"
        :small="true"
        :pageSizes="$store.state.pageSizes"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-row>
    <!-- 服务模态框 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      @close="handleClose"
    >
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size: 16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
          </span>
        </i>
      </label>
      <el-row>
        <el-steps
          :active="active"
          finish-status="success"
          space="100%"
          align-center
          style="margin-top: 20px"
        >
          <el-step :title="$t('rcsw.cjfw')"></el-step>
          <el-step :title="$t('rcsw.dybd')"></el-step>
          <el-step :title="$t('rcsw.ylfb')"></el-step>
        </el-steps>
      </el-row>
      <div v-show="active == 0">
        <el-card style="padding: 0 20% 0 10%">
          <el-form
            :model="CjfwruleForm"
            :rules="cjfwrules"
            ref="CjfwruleForm"
            label-width="120px"
            :validate-on-rule-change="false"
            size="small"
            v-show="active == 0"
          >
            <el-form-item :label="$t('rcsw.fwmc')" prop="fwmc" class="formClass">
              <el-input v-model="CjfwruleForm.fwmc"></el-input>
            </el-form-item>
            <el-form-item :label="$t('rcsw.fwlx')" prop="lxid">
              <el-select
                v-model="CjfwruleForm.lxid"
                style="width: 100%"
                @change="setfwlxmc"
              >
                <el-option
                  v-for="item in optionsFwlx"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('rcsw.fwjj')" prop="fwjj">
              <el-input
                type="textarea"
                :rows="5"
                v-model="CjfwruleForm.fwjj"
                maxlength="100"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('xmsq.queryFormqzrq')" prop="value2">
              <el-date-picker
                v-model="CjfwruleForm.value2"
                type="daterange"
                value-format="yyyyMMdd"
                :range-separator="$t('xmsq.to')"
                :start-placeholder="$t('xmsq.qsrq')"
                :end-placeholder="$t('xmsq.jzrq')"
                align="right"
                size="small"
                style="width: 100%"
                :picker-options="pickerOptions"
                @change="DatepickerChange"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              :label="$t('rcsw.scfj')"
              prop="fj"
              v-show="!(saveFlg == 'edit' && CjfwruleForm.lxid == '006')"
            >
              <el-upload
                class="upload-demo"
                :http-request="upLoad"
                :auto-upload="false"
                :multiple="true"
                action=""
                with-credentials
                :limit="5"
                :on-exceed="handleExceed"
                ref="upload"
                accept=".xls,.doc,.docx,.ppt,.xlsx,.pdf,.rar,.zip"
                :file-list="fileList"
              >
                <el-button slot="trigger" size="small" type="primary"
                  >{{$t('rcsw.djsc')}}</el-button
                >
              </el-upload>
            </el-form-item>
            <el-form-item
              :label="$t('rcsw.lsfj')"
              v-show="
                saveFlg == 'edit' &&
                  fileList.length > 0 &&
                  CjfwruleForm.lxid != '006'
              "
            >
              <el-upload
                class="upload-demo"
                :auto-upload="false"
                with-credentials
                action=""
                ref="lishiupload"
                :on-remove="handleRemove"
                :file-list="fileList"
              >
              </el-upload>
            </el-form-item>
            <el-form-item
              :label="$t('rcsw.fj')"
              v-show="
                saveFlg == 'edit' &&
                  fileList.length > 0 &&
                  CjfwruleForm.lxid == '006'
              "
            >
              <p v-for="(it,index) in fileList" :key="index">{{it.name}}</p>
            </el-form-item>
            <el-form-item
              :label="$t('rcsw.spry')"
              prop="sprzjh"
              v-if="CjfwruleForm.lxid != '006'"
            >
              <el-input
                v-model="CjfwruleForm.sprzjh"
                :placeholder="$t('rcsw.qsrsprgh')"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-card>
      </div>

      <div v-show="active == 1">
        <el-card style="padding: 0 10% 0 10%">
          <el-form
            :model="DybdruleForm"
            ref="DybdruleForm"
            size="small"
            v-show="active == 1"
          >
            <el-card>
              <label style="font-weight: bold;color: #606266">{{$t('rcsw.tdr')}}</label>
              <el-form-item :label="$t('rcsw.jbxx')+'：'" style="margin-top: 15px">
                <el-tag size="medium" type="warning">{{$t('rcsw.xm')}}</el-tag>
                <el-tag size="medium" type="warning" style="margin-left: 10px"
                  >{{$t('rcsw.xgh')}}</el-tag
                >
                <el-tag size="medium" type="warning" style="margin-left: 10px"
                  >{{$t('rcsw.department')}}</el-tag
                >
                <el-tag size="medium" type="warning" style="margin-left: 10px"
                  >{{$t('rcsw.lxdh')}}</el-tag
                >
                <el-tag size="medium" type="warning" style="margin-left: 10px"
                  >{{$t('rcsw.dzyx')}}</el-tag
                >
              </el-form-item>
            </el-card>

            <el-card
              style="margin-top: 20px"
              v-for="(item, index) in DybdruleForm.zdbtlist"
              :key="item.key"
            >
              <el-form-item
                :label="item.zdlxmc"
                style="font-weight: bold"
                :prop="'zdbtlist.' + index + '.zdbt'"
                :rules="{
                  required: true,
                  message: $t('rcsw.qtxbt'),
                  trigger: 'blur',
                }"
              >
                <el-checkbox style="margin-left: 70%" v-model="item.sfbt"
                  >{{$t('rcsw.required')}}</el-checkbox
                >
                <el-button
                  size="small"
                  icon="el-icon-delete"
                  style="float: right;"
                  round
                  @click="btdel(index)"
                ></el-button>
                <el-input
                  size="small"
                  v-model="item.zdbt"
                  style="margin-top: 15px"
                  :placeholder="$t('rcsw.qtxbt')"
                ></el-input>
              </el-form-item>
            </el-card>

            <el-card style="margin-top: 20px;border: lightgrey dashed 4px">
              <el-form-item>
                <el-button
                  style="width: 60px;height: 60px;padding: 0 0 0 0px;"
                  v-model="item.zdlx"
                  v-for="item in bdzdlx"
                  :key="item.key"
                  @click="addInputControl(item.zdlx, item.zdlxmc)"
                  ><div
                    style="font-size: 25px;font-family: 宋体;margin-bottom: 5px"
                  >
                    T
                  </div>
                  {{ item.zdlxmc }}</el-button
                >
              </el-form-item>
            </el-card>
          </el-form>
        </el-card>
      </div>
      <div v-show="active == 2">
        <el-card style="padding: 0 10% 0 10%">
          <el-form ref="YlfbruleForm" size="small" v-show="active == 2">
            <el-form-item label-width="20px">
              <div>{{ CjfwruleForm.fwmc }}</div>
              <div>{{$t('rcsw.type')}}：{{ CjfwruleForm.fwlxmc }}</div>
              <div>{{ CjfwruleForm.fwjj }}</div>
            </el-form-item>
            <el-card>
              <label style="font-weight: bold;color: #606266">{{$t('rcsw.tdr')}}</label>
              <el-form-item :label="$t('rcsw.jbxx')+'：'" style="margin-top: 15px">
                <el-tag size="medium" type="warning">{{$t('rcsw.xm')}}</el-tag>
                <el-tag size="medium" type="warning" style="margin-left: 10px"
                  >{{$t('rcsw.xgh')}}</el-tag
                >
                <el-tag size="medium" type="warning" style="margin-left: 10px"
                  >{{$t('rcsw.department')}}</el-tag
                >
                <el-tag size="medium" type="warning" style="margin-left: 10px"
                  >{{$t('rcsw.lxdh')}}</el-tag
                >
                <el-tag size="medium" type="warning" style="margin-left: 10px"
                  >{{$t('rcsw.dzyx')}}</el-tag
                >
              </el-form-item>
            </el-card>

            <el-card
              style="margin-top: 20px"
              v-for="item in DybdruleForm.zdbtlist"
              :key="item.key"
            >
              <el-form-item :label="item.zdbt" style="font-weight: bold">
                <span style="color: #606266">{{
                  item.sfbt ? "(必填)" : ""
                }}</span>
                <el-input size="small"></el-input>
              </el-form-item>
            </el-card>
          </el-form>
        </el-card>
      </div>
      <div slot="footer" class="dialog-footer" v-if="active == 0">
        <!--                <el-button @click="dialogFormVisible = false" size="small">取消</el-button>-->
        <el-button
          type="primary"
          size="small"
          @click="cjxzfw()"
          v-if="CjfwruleForm.lxid == '006'"
          >{{$t('rcsw.complete')}}</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="next('CjfwruleForm', 'cjfwnext')"
          v-else
          >{{$t('rcsw.next')}}</el-button
        >
      </div>
      <div slot="footer" class="dialog-footer" v-else-if="active == 1">
        <el-row class="rightClass">
          <el-col :span="12" style="text-align: left;">
            <el-button type="primary" size="small" @click="previous"
              >{{$t('rcsw.previous')}}</el-button
            >
          </el-col>
          <el-col :span="12">
            <el-button
              type="primary"
              size="small"
              @click="next('DybdruleForm', 'dybdnext')"
              >{{$t('rcsw.next')}}</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer" v-else-if="active == 2">
        <el-row class="rightClass">
          <el-col :span="12" style="text-align: left;">
            <el-button type="primary" size="small" @click="previous"
              >{{$t('rcsw.previous')}}</el-button
            >
          </el-col>
          <el-col :span="12">
            <el-button type="primary" size="small" @click="submitForm('tj')"
              >{{$t('rcsw.qrtj')}}</el-button
            >
            <el-button type="warning" size="small" @click="submitForm('cg')"
              >{{$t('rcsw.bccg')}}</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as rcsw from "@/api/rcsw";
export default {
  name: "myService",
  computed: {
    cjfwrules() {
      // 模态框数据校验规则
      return {
        fwmc: [
          {
            required: true,
            message: this.$t('rcsw.qsrfwmc'),
            trigger: "blur",
          },
        ],
        lxid: [
          {
            required: true,
            message: this.$t('rcsw.qxzfwlx'),
            trigger: "change",
          },
        ],
        fwjj: [
          {
            required: true,
            message: this.$t('rcsw.qsrfwjj'),
            trigger: "blur",
          },
        ],
        value2: [
          {
            required: true,
            message: this.$t('rcsw.qxzqzrq'),
            trigger: "change",
          },
        ],
        sprzjh: [
          {
            required: true,
            validator: this.validateSprzjh,
            trigger: "blur",
          },
        ],
      };
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      fileList: [],
      active: 0,
      queryForm: {
        sfqy: "1",
      },
      tableData: [],
      dialogFormVisible: false,
      dialogTitle: "", // 模态框标题
      dialogTitleIcon: "", // 模态框标题图标
      CjfwruleForm: {
        fwid: "",
        fwmc: "",
        lxid: "",
        fwjj: "",
        qssj: "",
        jzsj: "",
        fj: [],
        sprzjh: "",
        fjmc: "",
        value2: [],
        fwlxmc: "",
      },
      DybdruleForm: {
        zdbtlist: [],
      },
      bdzdlx: [],
      currentPage: 1, // 页码
      limit: this.$store.state.dataDisplayNum, // 分页显示条数
      total: 0, // 列表数据量
      pageSizes: this.$store.state.pageSizes, // 分页显示可选择条数
      tabLoading: true, // 表格请求数据loading层
      disabledFlg: false, // 输入框是否可编辑
      showFlg: false, // 元素是否显示
      btnColor: "1", // 聚焦按钮颜色
      saveFlg: "", // 保存操作区分
      optionsFwlx: [], // 服务类型
      fwid: "", // 服务id
      removelist: [], // 删除的附件信息
    };
  },
  methods: {
    upLoad(file, fileList) {
      this.fileList.push(file);
      this.formData.append("file", file.file);
    },
    handleRemove(file, fileList) {
      this.removelist.push({
        fwid: this.CjfwruleForm.fwid,
        filename: file.name,
      });
    },
    removefile() {
      this.$ajax.post("/api/removefile", this.removelist);
    },

    setfwlxmc(val) {
      var selected = {};
      selected = this.optionsFwlx.find((item) => {
        return item.value == val;
      });
      this.CjfwruleForm.fwlxmc = selected.label;
    },

    addInputControl(zdlx, zdlxmc) {
      this.DybdruleForm.zdbtlist.push({
        zdlx: zdlx,
        zdlxmc: zdlxmc,
        zdbt: "",
        sfbt: false,
        nrly: "wscj",
        fwid: this.fwid,
      });
    },
    btdel(val) {
      if (val >= 0) {
        this.DybdruleForm.zdbtlist.splice(val, 1);
      }
    },
    validateSprzjh(rule, value, callback) {
      var reg = new RegExp(/^[0-9a-z,]*$/);

      if (value == "") {
        callback(new Error(this.$t('rcsw.qsrsprgh')));
      } else if (!reg.test(value)) {
        callback(
          new Error(this.$t('rcsw.qsrsprgh'))
        );
      } else {
        this.$ajax
          .post("/api/checkSpr", this.$qs.stringify({ spr: value }))
          .then((res) => {
            if (res.data.code == "200") {
              callback();
            } else {
              callback(
                new Error(this.$t('rcsw.sprbcz'))
              );
            }
          })
          .catch((error) => {
            console.log(error);
            // this.$message.error(this.$t("resultCodeInfo.999"));
          });
      }
    },
    // 上传文件个数超出限制
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      this.$message.warning(this.$t('common.xzwj5'));
    },
    // 上一步
    previous() {
      if (this.active-- < 0) this.active = 0;
    },
    // 下一步
    next(formName, next) {
      this.$refs[formName].validate((valid) => {
        if (
          new Date(this.CjfwruleForm.value2[0]).getTime() <
          Date.now() - 8.64e7
        ) {
          this.CjfwruleForm.value2 = [];
          this.$message.error(this.$t('rcsw.qzrqxydqrq'));
          return false;
        }
        if (valid) {
          if (this.saveFlg === "add") {
            if (next == "cjfwnext") {
              this.savecjfw();
              this.getBdzdlxInfo();
            } else if (next == "dybdnext") {
              if (this.DybdruleForm.zdbtlist.length > 0) {
                this.savedybd();
              } else {
                this.$message.error(this.$t('rcsw.qtxbt'));
              }
            }
          } else if (this.saveFlg === "edit") {
            if (next == "cjfwnext") {
              this.savecjfw();
              if (this.removelist.length > 0) {
                this.removefile();
              }
              this.getBdzdlxInfo();
              this.getBdzdByFwid(this.fwid);
            } else if (next == "dybdnext") {
              if (this.DybdruleForm.zdbtlist.length > 0) {
                this.savedybd();
              } else {
                this.$message.error(this.$t('rcsw.qtxbt'));
              }
            }
          }
        } else {
          console.log("error next!!");
          return false;
        }
      });
    },
    // 创建下载服务
    cjxzfw() {
      this.$refs["CjfwruleForm"].validate((valid) => {
        this.formData = new FormData();
        this.formData.append("fwid", this.CjfwruleForm.fwid);
        this.formData.append("fwmc", this.CjfwruleForm.fwmc);
        this.formData.append("lxid", this.CjfwruleForm.lxid);
        this.formData.append("fwjj", this.CjfwruleForm.fwjj);
        this.formData.append("qssj", this.CjfwruleForm.qssj);
        this.formData.append("jzsj", this.CjfwruleForm.jzsj);
        this.formData.append("sprzjh", this.CjfwruleForm.sprzjh);
        this.formData.append("fjmc", this.CjfwruleForm.fjmc);
        this.formData.append("value2", this.CjfwruleForm.value2);
        this.formData.append("fwlxmc", this.CjfwruleForm.fwlxmc);
        this.formData.append("sfqy", "1");
        this.$refs.upload.submit();
        if (
          this.saveFlg != "edit"&&new Date(this.CjfwruleForm.value2[0]).getTime() <
          Date.now() - 8.64e7
        ) {
          this.CjfwruleForm.value2 = [];
          this.$message.error(this.$t('rcsw.qzrqxydqrq'));
          return false;
        } else if (this.fileList.length && this.fileList.length > 0) {
          rcsw.cjxzfw(this.formData).then((res) => {
            if (res.data.code == "200") {
              this.$message.success(res.data.data);
              this.dialogFormVisible = false;
            }
          });
        } else {
          this.$message.error(this.$t('rcsw.cjxzzsygwj'));
        }
      });
    },
    // 日期控件
    DatepickerChange() {
      if (this.CjfwruleForm.value2 != null) {
        this.CjfwruleForm.qssj = this.CjfwruleForm.value2[0];
        this.CjfwruleForm.jzsj = this.CjfwruleForm.value2[1];
      } else {
        this.CjfwruleForm.qssj = "";
        this.CjfwruleForm.jzsj = "";
      }
    },
    // 按钮聚焦
    btncolorTab(typeFlg, index) {
      this.btnColor = index;
      index != "3"
        ? (this.queryForm.sfqy = index)
        : (this.queryForm.sfqy = null);
      this.getwdfwinfo(typeFlg);
    },

    // 获取表单字段
    getBdzdByFwid(fwid) {
      this.$ajax
        .post("/api/getBdzdByFwid", this.$qs.stringify({ fwid: fwid }))
        .then((res) => {
          if (res.data.code == "200") {
            this.DybdruleForm.zdbtlist = res.data.data;
            for (let i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].sfbt == "1") {
                this.DybdruleForm.zdbtlist[i].sfbt = true;
              } else if (res.data.data[i].sfbt == "0") {
                this.DybdruleForm.zdbtlist[i].sfbt = false;
              }
            }
          } else {
            // this.$message.error(this.$t("resultCodeInfo." + res.data.code));
          }
        })
        .catch((error) => {
          // this.$message.error(this.$t("resultCodeInfo.999"));
        });
    },

    // 查询审批人
    selectSpr(fwid) {
      this.$ajax
        .post("/api/selectSpr", this.$qs.stringify({ fwid: fwid }))
        .then((res) => {
          if (res.data.code == "200") {
            this.CjfwruleForm.sprzjh = res.data.data;
          } else {
            // this.$message.error("审批人查找失败！");
          }
        })
        .catch((error) => {
          // this.$message.error(this.$t("resultCodeInfo.999"));
        });
    },
    /** 我的服务信息 */
    getwdfwinfo(typeFlg) {
      let _this = this;
      _this.tableData = [];
      if (typeFlg == "del" || typeFlg == "query") {
        _this.queryForm.currentPage = 1;
        _this.queryForm.limit = _this.$store.state.dataDisplayNum;
        _this.currentPage = 1;
      } else {
        _this.queryForm.currentPage = _this.currentPage;
        _this.queryForm.limit = _this.limit;
      }
      _this.tabLoading = true; // 关闭请求时的loading层
      _this.$ajax
        .post("/api/getwdfwinfo", _this.queryForm)
        .then((res) => {
          _this.tabLoading = false; // 关闭请求时的loading层
          if (res.data.code == "200") {
            if (res.data.data.length > 0) {
              _this.total = res.data.data[0].tableCount;
            } else {
              _this.total = 0;
            }
            _this.tableData = res.data.data;
          } else {
            // _this.$message.error(_this.$t("resultCodeInfo." + res.data.code));
          }
        })
        .catch((error) => {
          _this.tabLoading = false; // 关闭请求时的loading层
          // _this.$message.error(_this.$t("resultCodeInfo.999"));
        });
    },

    /** 生成服务id*/
    scfwid() {
      this.$ajax
        .post("/api/scFwid")
        .then((res) => {
          if (res.data.code == "200") {
            this.CjfwruleForm.fwid = res.data.data;
            this.fwid = res.data.data;
          } else {
            // this.$message.error(this.$t("resultCodeInfo." + res.data.code));
          }
        })
        .catch((error) => {
          // this.$message.error(this.$t("resultCodeInfo.999"));
        });
    },
    /** 获取表单字段类型信息*/
    getBdzdlxInfo() {
      this.$ajax
        .post("/api/getBdzdlxInfo")
        .then((res) => {
          if (res.data.code == "200") {
            this.bdzdlx = res.data.data;
          } else {
            // this.$message.error(this.$t("resultCodeInfo." + res.data.code));
          }
        })
        .catch((error) => {
          // this.$message.error(this.$t("resultCodeInfo.999"));
        });
    },
    clearFiles() {
      this.$refs["upload"].clearFiles();
      this.$refs["lishiupload"].clearFiles();
    },

    /** 关闭模态框*/
    handleClose(done) {
      this.clearFiles();
      this.$refs["CjfwruleForm"].resetFields();
      this.$refs["DybdruleForm"].resetFields();
      this.DybdruleForm.zdbtlist = [];
      this.removelist = [];
    },
    /** 打开模态框 */
    openDialog(flg, row) {
      if (flg == "add") {
        this.getBdzdlxInfo();
        this.scfwid();
        this.active = 0;
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = this.$t('rcsw.cjfw');
          this.dialogTitleIcon = "el-icon-document-add";
        });
      } else if (flg == "edit") {
        this.active = 0;
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = this.$t('rcsw.xdfw');
          this.dialogTitleIcon = "el-icon-edit-outline";
          this.CjfwruleForm.fwid = row.fwid;
          this.fwid = row.fwid;
          this.CjfwruleForm.fwmc = row.fwmc;
          this.CjfwruleForm.lxid = row.lxid;
          this.setfwlxmc(row.lxid);
          this.CjfwruleForm.fwjj = row.fwjj;
          this.CjfwruleForm.qssj = row.qssj;
          this.CjfwruleForm.jzsj = row.jzsj;
          this.CjfwruleForm.value2 = [
            new Date(
              row.qssj.slice(0, 4),
              row.qssj.slice(4, 6) - 1,
              row.qssj.slice(6, 8)
            ),
            new Date(
              row.jzsj.slice(0, 4),
              row.jzsj.slice(4, 6) - 1,
              row.jzsj.slice(6, 8)
            ),
          ];
          if (row.lxid != "006") {
            this.selectSpr(row.fwid);
          }
          this.selectfwfj(row.fwid);
        });
      } else if (flg == "del") {
        this.delWdfw(row.fwid);
      }
      this.saveFlg = flg;
    },
    /** 保存模态框数据 */
    submitForm(val) {
      this.$ajax
        .post(
          "/api/submitFwToApprove",
          this.$qs.stringify({ fwid: this.fwid, btn: val })
        )
        .then((res) => {
          this.dialogFormVisible = false;
          if (res.data.code == "200") {
            this.$message.success("操作成功！");
            this.getwdfwinfo();
          } else {
            // this.$message.error(this.$t("resultCodeInfo." + res.data.code));
          }
        })
        .catch((error) => {
          // this.$message.error(this.$t("resultCodeInfo.999"));
        });
    },
    /** 查询服务类型 */
    selectFwlx() {
      let _this = this;
      _this.optionsFwlx = [];
      _this.$ajax.post("/api/selectFwlx").then((res) => {
        if (res.data.code == "200") {
          for (let tmp of res.data.data) {
            _this.optionsFwlx.push({
              label: tmp.LXMC,
              value: tmp.LXID,
            });
          }
        } else {
          _this.$message.error(_this.$t("resultCodeInfo." + res.data.code));
        }
      });
      // _this.optionsFwlx.push({
      //     label: '申请',
      //     value: '001',
      // })
    },
    /** 根据fwid查询附件 */
    selectfwfj(fwid) {
      let _this = this;
      _this.fileList = [];
      _this.$ajax
        .post("/api/selectfwfj", _this.$qs.stringify({ fwid: fwid }))
        .then((res) => {
          if (res.data.code == "200") {
            for (let tmp of res.data.data) {
              _this.fileList.push({
                name: tmp.FJMC,
                // url: "",
              });
            }
          } else {
            // _this.$message.error(_this.$t("resultCodeInfo." + res.data.code));
          }
        })
        .catch((error) => {
          // _this.$message.error(_this.$t("resultCodeInfo.999"));
        });
    },
    /** 保存创建服务临时表*/
    savecjfw() {
      this.formData = new FormData();
      this.formData.append("fwid", this.CjfwruleForm.fwid);
      this.formData.append("fwmc", this.CjfwruleForm.fwmc);
      this.formData.append("lxid", this.CjfwruleForm.lxid);
      this.formData.append("fwjj", this.CjfwruleForm.fwjj);
      this.formData.append("qssj", this.CjfwruleForm.qssj);
      this.formData.append("jzsj", this.CjfwruleForm.jzsj);
      this.formData.append("sprzjh", this.CjfwruleForm.sprzjh);
      this.formData.append("fjmc", this.CjfwruleForm.fjmc);
      this.formData.append("value2", this.CjfwruleForm.value2);
      this.formData.append("fwlxmc", this.CjfwruleForm.fwlxmc);
      this.$refs.upload.submit(); //触发上传图片，开始一张一张的执行每个图片的http-request，遍历完成后此时的formData中的‘file’对应的就是待上传的图片对象数组了

      this.$ajax
        .post("/api/savecjfw", this.formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (res.data.code == "200") {
            if (this.active++ > 2) this.active = 0;
          }
        });
    },

    /** 保存定义表单临时表*/
    savedybd() {
      // if (this.active++ > 2) this.active = 0;
      this.$ajax
        .post("/api/savedybd", this.DybdruleForm.zdbtlist)
        .then((res) => {
          if (res.data.code == "200") {
            if (this.active++ > 2) this.active = 0;
          } else {
            // this.$message.error(this.$t("resultCodeInfo." + res.data.code));
          }
        })
        .catch((error) => {
          // this.$message.error(this.$t("resultCodeInfo.999"));
        });
    },

    /** 删除我的服务 */
    delWdfw(fwid) {
      let _this = this;
      _this
        .$confirm(this.$t('rcsw.scczsfjx'), this.$t('rcsw.tips'), {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$t('rcsw.confirmBtn'),
          cancelButtonText: this.$t('rcsw.cancelBtn'),
        })
        .then((res1) => {
          _this.$ajax
            .post("/api/delWdfw", _this.$qs.stringify({ fwid: fwid }))
            .then((res) => {
              if (res.data.code == "200") {
                _this.getwdfwinfo("del");
                _this.$message.success(this.$t('common.delSuccess'));
              } else {
                _this.$message.error(this.$t('common.delFail'));
              }
            })
            .catch((error) => {
              // _this.$message.error(_this.$t("resultCodeInfo.999"));
            });
        })
        .catch((action) => {
          // this.$message.info({
          //   message: action === 'cancel' ? '放弃保存并离开页面' : '停留在当前页面'
          // })
        });
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.getwdfwinfo();
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.currentPage = 1;
      this.getwdfwinfo();
    },
  },
  mounted() {
    this.getwdfwinfo();
    this.selectFwlx();
  },
};
</script>

<style lang="scss" scoped>
.leftClass {
  margin: 0 0 20px 0;
}
.btnColor {
  background-color: rgb(102, 177, 255);
}
.rightClass {
  margin: 10px 0;
}
</style>
